// src/i18n/locales/en/dietaryPreferences.ts
export const enDietaryPreferencesTranslations = {
  dietaryPreferences: {
    // Page titles
    title: 'Dietary Preferences',
    subtitle: 'Manage dietary preferences and restrictions for your menu items',
    
    // Actions
    addPreference: 'Add Preference',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    
    // Modal titles
    addNewPreference: 'Add New Dietary Preference',
    editPreference: 'Edit Dietary Preference',
    deletePreference: 'Delete Dietary Preference',
    
    // Form labels
    name: 'Name',
    namePlaceholder: 'e.g., Vegan, Gluten-Free, Halal',
    description: 'Description',
    descriptionPlaceholder: 'Describe this dietary preference',
    arabicName: 'Arabic Name',
    arabicNamePlaceholder: 'e.g., نباتي، خالي من الغلوتين، حلال',
    arabicDescription: 'Arabic Description',
    arabicDescriptionPlaceholder: 'Describe this dietary preference in Arabic',
    
    // Validation messages
    nameRequired: 'Name is required',
    descriptionRequired: 'Description is required',
    
    // Empty states
    noPreferences: 'No dietary preferences yet',
    
    // Confirmation messages
    deleteConfirmation: 'Are you sure you want to delete this dietary preference? This action cannot be undone.',
    
    // Success/Error messages
    addSuccess: 'Dietary preference added successfully',
    addError: 'Failed to add dietary preference',
    updateSuccess: 'Dietary preference updated successfully',
    updateError: 'Failed to update dietary preference',
    deleteSuccess: 'Dietary preference deleted successfully',
    deleteError: 'Failed to delete dietary preference',
  },
};
